(function () {
  if (window.__asmotaProductIeFallbackInitialized) {
    return;
  }
  window.__asmotaProductIeFallbackInitialized = true;

  function isIE() {
    var ua = window.navigator.userAgent;
    var msie = ua.indexOf('MSIE ');
    var trident = ua.indexOf('Trident/');
    return msie > 0 || trident > 0;
  }

  function bindFallback(container) {
    if (!isIE()) {
      return;
    }

    if (container.dataset.ieFallbackBound === 'true') {
      return;
    }

    var sectionId = container.getAttribute('data-section-id');
    var productFormId = container.getAttribute('data-product-form-id');
    if (!sectionId || !productFormId) {
      return;
    }

    var hiddenInput = document.querySelector('#' + productFormId + ' input[name="id"]');
    var variantSwitcher =
      document.querySelector('variant-radios[data-section="' + sectionId + '"]') ||
      document.querySelector('variant-selects[data-section="' + sectionId + '"]');
    var noScriptSource = document.querySelector('.product-form__noscript-wrapper-' + sectionId);

    if (!hiddenInput || !variantSwitcher || !noScriptSource) {
      return;
    }

    var noScriptInputWrapper = document.createElement('div');
    noScriptInputWrapper.innerHTML = noScriptSource.textContent;
    variantSwitcher.outerHTML = noScriptInputWrapper.outerHTML;

    var variantsSelect = document.querySelector('#Variants-' + sectionId);
    if (variantsSelect) {
      variantsSelect.addEventListener('change', function (event) {
        hiddenInput.value = event.currentTarget.value;
      });
    }

    container.dataset.ieFallbackBound = 'true';
  }

  function init(context) {
    var root = context && context.nodeType === 1 ? context : document;
    root.querySelectorAll('[data-ie-product-fallback="true"]').forEach(function (container) {
      bindFallback(container);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();